import * as React from "react";
import ctl from "@netlify/classnames-template-literals";
import { usePageLoadingState } from "./page-loading-state-provider";
import * as styles from "./page-loading-indicator.module.css";

const PageLoadingIndicator = () => {
  const { isPageLoading } = usePageLoadingState();
  return (
    <div className="h-[1px] w-full bg-zd-link fixed top-[1px] right-0 z-50">
      {isPageLoading && (
        <div
          className={ctl(`
            ${styles.loadingBar}
            bg-zd-black
          `)}
        ></div>
      )}
    </div>
  );
};

export { PageLoadingIndicator };
